import { ProductSubType, ProductType } from "../enums/xrm.constants";

// UIDATA

export class AppUiData {
  Prefix: any = [];
  Gender: any = [];
  Ethnicity: any = [];
  MilitaryBranch: any = [];
  MilitaryRank: any = [];
  StateProvinces: any = [];
  Countries: any = [];
  MedicalSchools: any = [];
  Residencies: any = [];
  Fellowships: any = [];
  BoardCertifications: any = [];
  MedicalLicenseTypeCodes: any = [];
  EmploymentStatus: any = [];
  PracticeLocation: any = [];
  ManualAccounts: any = [];
  Speciality: any = [];
  SubSpeciality: any = [];
  CareerStatus: any = [];
  PA: any = [];
  PG: any = [];
  Sections: any = [];
  Chapters: any = [];
  //AccountProducts: any = [];
  Pronouns: any = [];
  SexualOrientations: any = [];
  PrimaryLanguages: any = [];
  Disabilities: any = [];
  PrimaryPracticeGeography: any = [];
  PrimaryPracticeSettings: any = [];
  PrimaryReasonForJoining: any = [];



}

export class Address {
  address1: any = "";
  address2: any = "";
  address3: any = "";
  city: any = "";
  state: any = "";
  zip: any = "";
  country: any = "US";
}

export class Questionnaire {
  questiontext: any = "";
  qndefnid: any = "";
  questionKey: any = "";
  answertype: any = "";
  answerid: any = "";
  answervalue: any = "";
  answermetadata: any = "";
  answernotes: any = "";
  modifiedon: any = "";
}

export class Summary {
  personal: string = "";
  memberhip: string = "";
  education: string = "";
  sections: string = "";
  chapter: string = "";
}

// This is the same as line item in payment
export class OrderGenProduct {
  IsPrimaryChapter: boolean = false;
  Selected: boolean = false;
  ProductId: string = "";
  ProductIdname: string = "";
  ProductNumber: string = "";
  ProductSubType: ProductSubType;
  ProductType: ProductType;
  UnitPrice: number;
  PrimaryEmployer?: string = "";
  StartDate: boolean = false;
  EndDate: boolean = false;
}
